import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import SidebarTabs from 'components/SidebarTabs/SidebarTabs';

import { useGetActiveSidebarItemId } from 'hooks/useGetActiveSidebarItemId';

import { SidebarTabsItem } from 'types/sidebar';

import ApplicationResumeView from '../ApplicationResumeView/ApplicationResumeView';
import ApplicationView from '../ApplicationView/ApplicationView';
import InterviewView from '../InterviewView/InterviewView';
import OfferView from '../OfferView/OfferView';
import useGetApplication from '../hooks/useGetApplication';

export const APPLICATION_SIDEBAR_ITEMS_IDS = {
  APPLICATION: 1,
  OFFER: 2,
  INTERVIEW: 3,
  RESUME: 4
};

interface ApplicationSidebarProps {
  openItemId?: number;
}

const ApplicationSidebar: FC<ApplicationSidebarProps> = ({
  openItemId
}: ApplicationSidebarProps) => {
  const { isLoading, fetchApplicationData } = useGetApplication();
  const { t } = useTranslation();

  const allowedTabs = new Set<number>(
    Object.values(APPLICATION_SIDEBAR_ITEMS_IDS)
  );
  const activeItemId = useGetActiveSidebarItemId(allowedTabs, openItemId);

  const items: SidebarTabsItem[] = useMemo(
    () => [
      {
        id: APPLICATION_SIDEBAR_ITEMS_IDS.APPLICATION,
        title: t('sidebar.application.tab.main'),
        component: <ApplicationView isLoading={isLoading} />
      },
      {
        id: APPLICATION_SIDEBAR_ITEMS_IDS.INTERVIEW,
        title: t('sidebar.application.tab.interview'),
        component: <InterviewView fetchApplicationData={fetchApplicationData} />
      },
      {
        id: APPLICATION_SIDEBAR_ITEMS_IDS.OFFER,
        title: t('sidebar.application.tab.offer'),
        component: (
          <OfferView
            isLoading={isLoading}
            fetchApplicationData={fetchApplicationData}
          />
        )
      },
      {
        id: APPLICATION_SIDEBAR_ITEMS_IDS.RESUME,
        title: t('sidebar.application.tab.resume'),
        component: (
          <ApplicationResumeView
            isLoading={isLoading}
            fetchApplicationData={fetchApplicationData}
          />
        )
      }
    ],
    [isLoading, fetchApplicationData]
  );

  return (
    <div>
      <SidebarTabs
        items={items}
        isChangeCurrentTabOnNewItems={false}
        openItemId={activeItemId}
      />
    </div>
  );
};

export default ApplicationSidebar;
